import { render, staticRenderFns } from "./EventPersonal.vue?vue&type=template&id=5bf51412"
import script from "./EventPersonal.vue?vue&type=script&lang=js"
export * from "./EventPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports